import styled from "@emotion/styled";
import Button from "@material-ui/core/Button";
import { units } from "../../../types/units";

export const AppWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: top;
  justify-content: start;
  background-color: ${({ theme }) => theme.colors.white};
`;
export const PageWrapper = styled.main`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  flex-grow: 1;
  position: relative;
`;
export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  min-height: 80vh;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
`;

export const JumptoLink = styled(Button)`
  border: 2px solid #026495;
  position: absolute;
  opacity: 0;
  padding: 1rem;
  left: 0;

  ${units({
    backgroundColor: "white",
    "&:focus": {
      color: "black",
      backgroundColor: "lightBlue",
      opacity: "1",
      "z-index": "1000",
      borderColor: "#00CAFF !important",
      
    },
    "&#main-bottom": {
      bottom: "0",
      left: "auto",
      right: "0",
    },
  })};
`;
